import { companyMutationTypes } from './mutation-types';

export const mutations = {
  [companyMutationTypes.SET_REQUEST_STATUS] (state, status) {
    state.requestStatus = status;
  },
  [companyMutationTypes.SET_COMPANIES] (state, companyList) {
    state.companies = companyList;
  },
  [companyMutationTypes.SET_ACTIVE_COMPANY] (state, company) {
    state.activeCompany = company;
  },
};
